import React from 'react';

import { BloodworkDisplay } from '../components/bloodworkz/bloodwork-display';

import { observer, inject } from 'mobx-react';
import { BloodworkEntryStore } from '../stores/bloodwork-entry-store';
import { ClientEntryStore } from '../stores/client-entry-store';
import { FurtherConsiderationsEntryStore } from '../stores/further-considerations-entry-store';
import { UserProfileUIStore } from '../stores/user-profile-ui-store';

interface BloodworkDisplayContainerProps {
  userProfileUIStore?: UserProfileUIStore;
  bloodworkEntryStore?: BloodworkEntryStore;
  clientEntryStore?: ClientEntryStore;
  furtherConsiderationsEntryStore?: FurtherConsiderationsEntryStore;
  history?: any;
}

@inject(
  'bloodworkEntryStore',
  'clientEntryStore',
  'furtherConsiderationsEntryStore',
  'userProfileUIStore',
)
@observer
export class BloodworkDisplayContainer extends React.Component<
  BloodworkDisplayContainerProps,
  {}
> {
  componentWillMount() {
    const {
      userProfileUIStore,
      furtherConsiderationsEntryStore,
      bloodworkEntryStore,
      clientEntryStore,
    } = this.props;
    userProfileUIStore.loadCurrentUserProfile();
    furtherConsiderationsEntryStore.loadFurtherConsiderations();
    bloodworkEntryStore.loadBloodworkRanges();
    if (clientEntryStore && !clientEntryStore.clients) {
      clientEntryStore.loadCurrentClients();
    }
  }

  scrollTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  render() {
    const {
      userProfileUIStore,
      bloodworkEntryStore,
      clientEntryStore,
      furtherConsiderationsEntryStore,
    } = this.props;

    return (
      <BloodworkDisplay
        currentUserProfile={userProfileUIStore.currentUserProfile}
        testResultsPanelLabel="Recently Added Test Results"
        bloodworks={bloodworkEntryStore.bloodworks}
        bloodworkEntryStore={bloodworkEntryStore}
        refreshBloodworks={bloodworkEntryStore.refreshBloodworks}
        furtherConsiderations={
          furtherConsiderationsEntryStore.furtherConsiderations
        }
        allowLoadMoreTestResults={true}
        history={this.props.history}
        showAnalyzeTableButton={true}
        updateClient={clientEntryStore ? (client) => clientEntryStore.updateClientFields(client) : undefined}
        currentClients={clientEntryStore?.clients}
      />
    );
  }
}
